<script>
export default {
    name: "ModalShow",
    props: {
        show: Boolean,
        dimension: String
    },
}
</script>
<template>
  <div class="modal is-active" v-show="show">
      <div class="modal-background" ></div>
      <div class="modal-card rounded" :class="dimension ? dimension : `h-64`">
        <header class="modal-card-head  bg-gray-300 p-3">
          <h5 class="modal-card-title"><slot name="title"></slot></h5>
        </header>
        <section class="modal-card-body">
          <slot name="modal-body"></slot>
        </section>
        <footer class="modal-card-foot flex justify-end bg-gray-300 p-1">
          <slot name="modal-footer"></slot>
        </footer>
      </div>
  </div>
</template>
